import React from 'react';
import { asyncComponent } from 'react-async-component';
import Loading from '../../asyncComps/Loading';

export default asyncComponent({
    resolve: () => import('./index'),
    LoadingComponent: ()=>{
        return (
            <Loading ecId={`${this && this.props && this.props.ecId || ''}_Loading@84a3hy`} />
        )
    }
});


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/smartGuessMap/smartGuessAsync.js